import { RADIUS_LG, SPACING_1_5 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const StyledBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: ${SPACING_1_5};
  padding-left: ${SPACING_1_5};
  color: #181646; // @todo: use token
  border: 1px solid #181646; // @todo: use token
  border-radius: ${RADIUS_LG};
  height: 1.75rem;
  width: fit-content;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: -0.03rem;
`;

type Props = {
  text: string | null | undefined;
};

const Badge = ({ text }: Props) => {
  if (!text) return null;
  return <StyledBadge>{text}</StyledBadge>;
};

export default Badge;
